import { configsManager } from '../../configs/configs';

const auth = configsManager.configs.authEndpoint;

const service = configsManager.configs.serviceEndpoint;

export default {
  LOGIN: `${auth}/login`,
  SIGNUP: `${auth}/signup`,
  CONFIGS: `${service}/configurations`,
  SHOPS: `${service}/shops`,
  ATTRIBUTES: `${service}/attributes`,
  ATTRIBUTE: `${service}/attribute`,
  AUTOCOMPLETE_CATEGORY: `${service}/category-group/autocomplete`,
  VALUE: `${service}/value`,
  RULE: `${service}/rule`,
  SEARCH_VALUE: `${service}/search/value`,
  SEARCH_RULE: `${service}/search/rule`
};
